import React from "react";
import "./OrderStatusBar.scss";
import { useAuth } from "../../Context/useAuth";
import Moment from "react-moment";
import { useOrder } from "../../Context/useOrder";
import { Button } from "react-bootstrap";

interface Props {
  allowPrint?: boolean;
}
const OrderStatusBar = (props: Props) => {
  const { isAuthenticated } = useAuth();
  const { getCurrentOrder } = useOrder();
  const order = getCurrentOrder();
  const isOverdue: boolean = order && order.dueDate !== undefined ? new Date() > order?.dueDate : false;
  const dueDateClssClass = `bg-info p-1 px-2 rounded ${isOverdue ? "bg-danger text-white" : "bg-info"}`;
  const handlePrint = () => {
    window.print();
  };
  return (
    <>
      {order && order.transRefCode && order.dueDate && isAuthenticated() && (
        <div className="row sticky-top-2">
          <div className="col-12 my-2">
            <div className="container-limited-width d-flex justify-content-between align-items-center">
              <div className="d-flex flex-grow-1 justify-content-between align-items-center me-3">
                <div style={{ fontSize: "1.4rem" }}>
                  <b>{order.transRefCode}</b>
                </div>
                {props.allowPrint && (
                  <div>
                    <Button variant="outline-secondary" size="sm" onClick={handlePrint} title="Print" className="px-3">
                      <i className="fa fa-barcode" aria-hidden="true"></i>
                    </Button>
                  </div>
                )}
              </div>
              <span className={dueDateClssClass}>
                Due:{" "}
                <b>
                  <Moment date={order.dueDate} format="ddd DD/MM/YYYY" />
                </b>
              </span>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default OrderStatusBar;
